export class Debt {
    name: string;
    expireIn: number;
    monthRate: number;
    debtRes: number;
    debtYear: number;
    note: string;
    expireInYear: number;
}
